// extracted by mini-css-extract-plugin
module.exports = {"reason":"a10a3f92e9--reason--vyJQR"};